































import { Component, Prop, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { IPromotionProduct } from "@/models/promotions";

@Component({
  components: {
    "discount-and-conditions": () =>
      import(
        "@/components/app/admin/catalogue/promotions/discountAndConditions.vue"
      )
  }
})
export default class ManageMandatoryConfigurationModal extends Mixins(
  HasValidation
) {
  // Props
  @Prop({ default: () => ({}) })
  public formData!: IPromotionProduct;

  @Prop({ default: false })
  public showWarningMessage!: boolean;

  // Data
  public isProcessing = false;
  public form: any = {
    currencies: [],
    pricelists: [],
    billing_cycles: []
  };

  // Lifecycle methods
  public created() {
    if (!this.$_.isEmpty(this.formData)) {
      this.form = this.$_.cloneDeep(this.formData);
    }
  }

  // Mehtods
  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      this.$emit("success", this.form);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
